import { select, put } from "redux-saga/effects";

import { MODAL_TYPES } from "../constants/modals";
import * as actions from "../constants/actions";
import { getEditorModel, getEditorModelId } from "../selectors";

export function* createEditorConfigs() {
  const { auth, folders } = yield select();

  if (auth.loggedIn) {
    if (folders.allIds.length) {
      yield put(actions.openModal({ modalType: MODAL_TYPES.CREATE_MODEL }));
    } else {
      yield put(actions.openModal({ modalType: MODAL_TYPES.CREATE_FOLDER }));
    }
  } else {
    yield put(actions.openModal({ modalType: MODAL_TYPES.SIGNIN }));
  }
}

export function* saveEditorConfigs() {
  const id = yield select(getEditorModelId);
  const params = yield select(getEditorModel);

  yield put(actions.updateModel({ id, params }));
  yield put(actions.openModal({ modalType: MODAL_TYPES.EDITOR_VALIDATION }));
}



// WEBPACK FOOTER //
// ./src/sagas/editor.js